<div dir="{{textDir}}">

    <ngx-loading-bar [color]="'#39A189'" [includeSpinner]="true" [height]="'4px'"></ngx-loading-bar>
    <app-loader></app-loader>
    <app-tap-to-top></app-tap-to-top>

    <router-outlet></router-outlet>


</div>